// VenmoButton.jsx
import React from "react";

const VenmoButton = ({ username, amount, note }) => {
    const handleVenmoClick = () => {
        const venmoUrl = `https://venmo.com/${username}?txn=pay&amount=${amount}&note=${encodeURIComponent(note)}`;
        window.open(venmoUrl, "_blank");
    };

    return (
        <div className="venmo-button-container">
            <button
                className="venmo-button bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
                onClick={handleVenmoClick}
            >
                Pay with Venmo
            </button>
        </div>
    );
};

export default VenmoButton;
